import React from 'react';

import { faRotate, faServer } from '@fortawesome/sharp-regular-svg-icons';
import { ContextActionType } from '@europrocurement/flexy-components';
import { FactureAchat } from '@europrocurement/l2d-domain';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { useSyncG3 } from '../useSyncG3';

export type SyncG3Props = {
    invoice?: FactureAchat;
    forced?: boolean;
};

const useSyncG3ContextAction = ({ invoice, forced = true }: SyncG3Props): ContextActionType => {
    const { synchroG3Facture } = useSyncG3();

    return {
        name: 'Synchro G3',
        icon: (
            <FaOptionIcon
                icon={faServer}
                option={faRotate}
                size="1x"
                color="blueGrey.main"
                optionColor="blueGrey.dark"
                iconProps={{
                    radius: 100,
                }}
            />
        ),
        action: () => {
            if (invoice) {
                synchroG3Facture(invoice, forced);
            }
        },
    };
};

export default useSyncG3ContextAction;
